import { createSlice } from '@reduxjs/toolkit';
import BaseError from 'utils/base-error';
// eslint-disable-next-line no-restricted-imports
import { createStrapiMediaUrl, fetchLeadFormThunk } from 'shared/lib';
import { SweetShopArticlePageState } from './state';
import { SweetShopArticlePageActions } from './actions';
import {
    createSweetShopArticleFromGetSweetShopArticleByUidApiResponse,
} from '../utils';

const initialState: SweetShopArticlePageState = {
    loaded: false,
    errors: [],
};

export const sweetShopArticlePageSlice = createSlice({
    name: 'sweetShopArticlePageSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            SweetShopArticlePageActions.getSweetShopArticleByUid.fulfilled,
            (state, action) => {
                const response = action.payload;

                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    try {
                        console.log(response);
                        // eslint-disable-next-line max-len
                        state.sweetShopArticle = createSweetShopArticleFromGetSweetShopArticleByUidApiResponse(
                            response.data,
                        );
                    } catch (e) {
                        state.errors.push(new BaseError(400, String(e)));
                    }
                }
            },
        );
        builder.addCase(
            fetchLeadFormThunk.fulfilled,
            (state, action) => {
                const response = action.payload;
                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    state.leadFormPdf = response.data.data.commercialOfferFile ? {
                        url: createStrapiMediaUrl(response.data.data.commercialOfferFile.url),
                    } : undefined;

                    state.loaded = true;
                }
                state.loaded = true;
            },
        );
    },
});
